import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef
} from '@angular/core';

import { Router } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import { AppConstants } from '../AppConstants';
import { AuthService } from '../service/auth.service';
import { UIRoutes } from '../UIRoutes';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';

interface TenantConfig {

  tenantId: number;

  tenantName: string;

  sequence: number;

  services: string[];

}
@Component({
  selector: 'app-tenants-grid',
  templateUrl: './tenants-grid.component.html',
  styleUrls: ['./tenants-grid.component.css']
})

export class TenantsGridComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router,
    private modalService: NgbModal,
    private snackBar: MatSnackBar,
    private http: HttpClient
  ) { }

  SA = false;

  rowData = [];

  rowData2 = [];

  externalUserContext;

  currentUserContext;

  roleId;
  enablePaymentLink: boolean = false;
  feeId: any;

  // Single Session fee columns
  singlePgFee: number = 0;
  singlePgFeeType: string = 'percentage';
  singleCashFee: number = 0;
  singleCashFeeType: string = 'percentage';
  singleEndUserFee: number = 0;
  singleEndUserFeeType: string = 'percentage';

  // Multi Session / Flexi fee columns
  multiPgFee: number = 0;
  multiPgFeeType: string = 'percentage';
  multiCashFee: number = 0;
  multiCashFeeType: string = 'percentage';
  multiEndUserFee: number = 0;
  multiEndUserFeeType: string = 'percentage';
  selectedTenantId;

  tenantStatusUpdating = {};

  @ViewChild('confirmCancel')
  confirmCancel!: TemplateRef<any>;

  //------------------------------------------------------
  // Tenant Configuration
  //------------------------------------------------------

  tenantConfig: TenantConfig[] = [];

  sequence = 9999;

  selectedServices: string[] = [];

  availableServices: string[] = [

    'Badminton',

    'Cricket',

    'Football',

    'Gym',

    'Dance',

    'Swimming',

    'Pickleball',

    'Table Tennis',

    'Tennis',

    'Basketball',

    'Volleyball',

    'Yoga',

    'Karate',

    'Skating',

    'Athletics',

    'Boxing',

    'Crossfit',

    'Zumba',

    'Chess',

    'Snooker',

    'Billiards',

    'Archery'

  ];

  //------------------------------------------------------
  // AG Grid Columns
  //------------------------------------------------------

  columnDefs = [
       { headerName: 'TENANT NAME', field: 'tenantName', width: 250 },  // Names can be long, so more space is needed
        { headerName: 'TENANT ID', field: 'id', width: 120 },            // Fixed-length identifier, short
        { headerName: 'ID', field: 'accountId', width: 120 },            // Another identifier, similar to Tenant ID
        { headerName: 'PHONE', field: 'phoneNumber', width: 180 },       // Needs space for international formats
        { headerName: 'CATEGORY', field: 'tenantCategoryId', width: 150 }, // Typically a small category name or ID
        { headerName: 'ACTIVATION', field: 'status', width: 130, cellRenderer: (params)=> {
          const button = document.createElement('button');
          button.type = 'button';
          button.innerText = this.getTenantStatusActionLabel(params.data.status);
          button.classList.add('btn', 'btn-sm', this.isTenantActive(params.data.status) ? 'btn-outline-danger' : 'btn-outline-success', 'tenant-status-action');
          button.disabled = !!this.tenantStatusUpdating[params.data.id];
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.toggleTenantStatus(params.data);
          });
          return button;
        } },
        { headerName: 'EDIT', field: 'edit', width: 90,cellRenderer: (params)=> {
          const button = document.createElement('button');
          const icon = document.createElement('i');
          button.type = 'button';
          button.classList.add('btn', 'btn-sm', 'btn-link', 'edit-tenant');
          icon.innerText = 'edit';
          icon.classList.add('material-icons');
          button.appendChild(icon);
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.openPopup(params.data.id);
          });
          return button;
        } }
  ];
  //------------------------------------------------------
  // Initialization
  //------------------------------------------------------

  ngOnInit() {

    this.externalUserContext =
      sessionStorage.getItem(
        AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT
      );

    this.currentUserContext =
      sessionStorage.getItem(
        AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT
      );

    if (this.externalUserContext) {

      this.roleId =
        JSON.parse(this.externalUserContext).roleId;

    } else if (this.currentUserContext) {

      this.roleId =
        JSON.parse(this.currentUserContext).roleId;

    } else {

      this.roleId = 0;

    }

    if (this.roleId == 1) {

      this.SA = true;

      this.loadTenantConfig();

    } else {

      this.SA = false;

    }

  }

  //------------------------------------------------------
  // Load tenant-config.json
  //------------------------------------------------------

  loadTenantConfig() {

    this.http
      .get<any>('assets/tenant-config.json')

      .subscribe(

        data => {

          this.tenantConfig = data.tenants || [];

          this.getAllTenants();

        },

        error => {

          console.log(
            'tenant-config.json not found.'
          );

          this.tenantConfig = [];

          this.getAllTenants();

        }

      );

  }

  //------------------------------------------------------
  // Load tenants from API and merge JSON config
  //------------------------------------------------------

  getAllTenants() {

    this.authService
      .getAlltenants()

      .subscribe(

        (response: any[]) => {

          console.log("Tenants :", response);

          response.forEach(tenant => {

            const config =
              this.tenantConfig.find(

                x => x.tenantId == tenant.id

              );

            if (config) {

              tenant.sequence = config.sequence;

              tenant.services = config.services;

              tenant.servicesDisplay =
                config.services.join(", ");

            }

            else {

              tenant.sequence = 9999;

              tenant.services = [];

              tenant.servicesDisplay = "";

            }

          });

          response.sort(

            (a, b) => a.sequence - b.sequence

          );

          this.rowData = response;

        },

        error => {

          console.log(error);

        }

      );

  }

  //------------------------------------------------------
  // Edit popup
  //------------------------------------------------------

  openPopup(tenantId) {

    this.selectedTenantId = tenantId;
    console.log('Opening popup for tenant:', tenantId);

    // Fetch existing fees for this tenant
    this.authService.getTenantFee(tenantId).subscribe(
      (response: any) => {
        console.log('Tenant fees:', response);
        if (response) {
          this.feeId = response.id;
          this.singlePgFee       = response.singlePgFee       || 0;
          this.singlePgFeeType   = response.singlePgFeeType   || 'percentage';
          this.singleCashFee     = response.singleCashFee     || 0;
          this.singleCashFeeType = response.singleCashFeeType || 'percentage';
          this.singleEndUserFee      = response.singleEndUserFee      || 0;
          this.singleEndUserFeeType  = response.singleEndUserFeeType  || 'percentage';
          this.multiPgFee        = response.multiPgFee        || 0;
          this.multiPgFeeType    = response.multiPgFeeType    || 'percentage';
          this.multiCashFee      = response.multiCashFee      || 0;
          this.multiCashFeeType  = response.multiCashFeeType  || 'percentage';
          this.multiEndUserFee       = response.multiEndUserFee       || 0;
          this.multiEndUserFeeType   = response.multiEndUserFeeType   || 'percentage';
        }
        this.openModal();
      },
      (error) => {
        console.error('Error fetching tenant fees:', error);
        // Initialize with default values if no fees exist
        this.resetFeeValues();
        this.openModal();
      }
    );
  }


  //------------------------------------------------------
  // Modal
  //------------------------------------------------------

  openModal() {
    const modalRef = this.modalService.open(this.confirmCancel, { size: 'lg' });

    modalRef.result

      .then(result => {

        if (result == 'yes') {

          this.saveTenantFee();

        }

      })

      .catch(() => { });

  }

  //------------------------------------------------------
  // Save Tenant Configuration
  //------------------------------------------------------

  saveTenantConfiguration() {

    const tenant = this.rowData.find(
      x => x.id == this.selectedTenantId
    );

    let config = this.tenantConfig.find(
      x => x.tenantId == this.selectedTenantId
    );

    if (config) {

      config.tenantName = tenant ? tenant.tenantName : "";

      config.sequence = this.sequence;

      config.services = [...this.selectedServices];

    }
    else {

      this.tenantConfig.push({

        tenantId: this.selectedTenantId,

        tenantName: tenant ? tenant.tenantName : "",

        sequence: this.sequence,

        services: [...this.selectedServices]

      });

    }

  }

  //------------------------------------------------------
  // Download tenant-config.json
  //------------------------------------------------------

  downloadConfiguration() {

    const data = {

      tenants: this.tenantConfig

    };

    const blob = new Blob(

      [

        JSON.stringify(

          data,

          null,

          4

        )

      ],

      {

        type: 'application/json'

      }

    );

    const url =
      window.URL.createObjectURL(blob);

    const a =
      document.createElement('a');

    a.href = url;

    a.download = 'tenant-config.json';

    a.click();

    window.URL.revokeObjectURL(url);

  }

  //------------------------------------------------------
  // Save Fees
  //------------------------------------------------------

  saveTenantFee() {

    const feeData = {

      id: this.feeId,

      tenantId: this.selectedTenantId,
      singlePgFee:      this.singlePgFee,
      singlePgFeeType:  this.singlePgFeeType,
      singleCashFee:     this.singleCashFee,
      singleCashFeeType: this.singleCashFeeType,
      singleEndUserFee:      this.singleEndUserFee,
      singleEndUserFeeType:  this.singleEndUserFeeType,
      multiPgFee:       this.multiPgFee,
      multiPgFeeType:   this.multiPgFeeType,
      multiCashFee:      this.multiCashFee,
      multiCashFeeType:  this.multiCashFeeType,
      multiEndUserFee:       this.multiEndUserFee,
      multiEndUserFeeType:   this.multiEndUserFeeType
    };

    this.authService

      .saveTenantFee(feeData)

      .subscribe(

        response => {

          //-------------------------------------
          // Save Tenant Config
          //-------------------------------------

          this.saveTenantConfiguration();

          //-------------------------------------
          // Download JSON
          //-------------------------------------

          //this.downloadConfiguration();

          //-------------------------------------
          // Refresh Grid
          //-------------------------------------

          this.getAllTenants();

          this.snackBar.open(

            'Tenant configuration saved successfully.',

            '',

            {

              duration: 7000,

              horizontalPosition: 'center',

              verticalPosition: 'bottom',

              panelClass: ['snackbar-success']

            }
          )
        });

  }

  resetFeeValues() {
    this.singlePgFee = 0;       this.singlePgFeeType = 'percentage';
    this.singleCashFee = 0;     this.singleCashFeeType = 'percentage';
    this.singleEndUserFee = 0;  this.singleEndUserFeeType = 'percentage';
    this.multiPgFee = 0;        this.multiPgFeeType = 'percentage';
    this.multiCashFee = 0;      this.multiCashFeeType = 'percentage';
    this.multiEndUserFee = 0;   this.multiEndUserFeeType = 'percentage';
  }

  isTenantActive(status) {
    return status && status.toLowerCase() === AppConstants.STATUS_ACTIVE.toLowerCase();
  }

  getTenantStatusActionLabel(status) {
    return this.isTenantActive(status) ? 'Deactivate' : 'Activate';
  }

  getNextTenantStatus(status) {
    return this.isTenantActive(status) ? AppConstants.STATUS_INACTIVE : AppConstants.STATUS_ACTIVE;
  }

  toggleTenantStatus(tenant) {
    const nextStatus = this.getNextTenantStatus(tenant.status);
    this.tenantStatusUpdating[tenant.id] = true;

    this.authService.updateTenantStatusByTenantId(tenant.id, nextStatus).subscribe(
      (response: any) => {
        tenant.status = response && response.status ? response.status : nextStatus;
        this.rowData = [...this.rowData];
        this.tenantStatusUpdating[tenant.id] = false;
        this.snackBar.open('Tenant ' + tenant.status.toLowerCase() + ' successfully!', '', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['snackbar-success']
        });
      },
      (error) => {
        this.tenantStatusUpdating[tenant.id] = false;
        this.snackBar.open('Tenant status update failed!', '', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['snackbar-error']
        });
      }
    );
  }



  //------------------------------------------------------
  // Grid
  //------------------------------------------------------

  onRowClicked(event: any) {


    const clickedColumn =
      event.column &&
      event.column.getColId
        ? event.column.getColId()
        : '';

    if (

      clickedColumn == 'edit' ||

      clickedColumn == 'status'

    ) {

      return;

    }

    AppConstants.SESSION_STORAGE_TENANTID =
      event.data.id;
    sessionStorage.setItem('selected-tenant-id', String(event.data.id));
    this.authService.persistLogin();

    this.router.navigate([

      UIRoutes.ROUTING_MODULE_LANDING_PAGE +

      '/' +

      UIRoutes.ROUTING_MODULE_COMPANY_PROFILE

    ]);

  }

  onGridReady(params) {

  }

  //------------------------------------------------------
  // Create Tenant
  //------------------------------------------------------

  CreateNewTenant() {

    this.router.navigateByUrl(

      UIRoutes.ROUTING_MODULE_FACILITY_DETAILS

    );

  }

}
